import { LossType } from "@api/operations.generated";

export const mapLossType = (value: LossType | null): string => {
  switch (value) {
    case LossType.TheftOrVandalism:
      return "Theft/Vandalism";
    case LossType.WeatherOrPropertyDamage:
      return "Weather/Property Damage";
    case LossType.FireOrSmokeDamage:
      return "Fire/Smoke Damage";
    case LossType.WaterDamage:
      return "Water Damage";
    case LossType.Liability:
      return "Liability";
    case LossType.Other:
      return "Other";
    default:
      return "";
  }
};
